import { render, staticRenderFns } from "./CompanyOverview.vue?vue&type=template&id=54a871fc"
import script from "./CompanyOverview.vue?vue&type=script&lang=ts"
export * from "./CompanyOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports